export const TOGGLE_SIDEBAR = 'TOGGLE_SIDEBAR';
export const SET_PAGE_TITLE = 'SET_PAGE_TITLE';
export const SET_PAGE_BREADCRUMBS = 'SET_PAGE_BREADCRUMBS';
export const SET_PAGE_HEADER_ENABLED = 'SET_PAGE_HEADER_ENABLED';
export const TOGGLE_FULLSCREEN = 'TOGGLE_FULLSCREEN';



// WEBPACK FOOTER //
// ./src/store/app/mutation-types.js